/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import ScrollColumn2D from './scrollcolumn2d';
import CartesianStackGroup from '../_internal/datasets/groups/cartesian.stack';
/**
 * Creates ScrollStackedColumn2D class
 */
class ScrollStackedColumn2D extends ScrollColumn2D {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'ScrollStackedColumn2D';
  }

  /**
   * Constructor fn of ScrollStackedColumn2D class
   */
  constructor () {
    super();
    this.canvasborderthickness = 1;
    this.avgScrollPointWidth = 75;
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'ScrollStackedColumn2D';
  }
  /**
   * Sets default chart configuration
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = 'Scrollable Stacked Column Chart';
    config.isstacked = true;
  }
  /**
   * Return Dataset Group class
   * @return {Class} CartesianStackGroup class
   */
  getDSGroupdef () {
    return CartesianStackGroup;
  }
}
export default ScrollStackedColumn2D;
